import z from 'zod';

export const GetParamsSchema = z.object({
  page: z.number().optional(),
  rows: z.number().optional(),
  sort: z.string().optional(),
  order: z.enum(['asc', 'desc']).optional()
});
